import React, { useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./Otp.module.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const Otp = () => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [optinput, setOptinput] = useState("");
  let unverified_email = null;
  let unverified_phone_number = null;
  if (typeof localStorage !== "undefined") {
    unverified_email = localStorage.getItem("unverified_email");
    console.log(unverified_email);
  }
  if (typeof localStorage !== "undefined") {
    unverified_phone_number = localStorage.getItem("unverified_phone_number");
    console.log(unverified_phone_number);
  }
  const submit = () => {
    if (!optinput || optinput?.length !== 6) {
      alert("OTP length must be 6.");
      return;
    }
    if (unverified_email) {
      axios
        .post(backend_base + "/user/otp/verify", {
          email: unverified_email,
          otp: optinput,
        })
        .then((response) => {
          if (response.status === 200) {
            //goto next page
            console.log("Success");
            console.log(response.data);
            if (typeof localStorage !== "undefined") {
              localStorage.setItem("verified_email", unverified_email);
              localStorage.removeItem("unverified_email");
              localStorage.setItem("registration_token", response.data.token);
              navigate("/member-registration");
            }
          } else {
            alert("falied to update.");
            console.log("Failure");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (unverified_phone_number) {
      axios
        .post(backend_base + "/user/otp/phone/verify", {
          phone: unverified_phone_number,
          otp: optinput,
        })
        .then((response) => {
          if (response.status === 200) {
            //goto next page
            console.log("Success");
            console.log(response.data);
            if (typeof localStorage !== "undefined") {
              localStorage.setItem("verified_phone", unverified_phone_number);
              localStorage.removeItem("unverified_phone_number");
              localStorage.setItem("registration_token", response.data.token);
              navigate("/member-registration");
            }
          } else {
            alert("falied to update.");
            console.log("Failure");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <>
      <Header />
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "calc(100vh - 287px)", marginTop: "160px" }}
      >
        <div className={styles.otp}>
          <div className={styles.opt_content}>
            <h6 className={styles.opt_title}>認証メール送信完了</h6>
            <h6 className={styles.opt_subtitle}>
              Eメールまたは携帯電話に届いた６桁の番号を入力して下さい。
            </h6>
            <div className="text-center">
              <input
                onChange={(e) => setOptinput(e.target.value)}
                className={styles.otp_input}
                type="text"
                value={optinput}
                placeholder="6桁の認証番号"
              />
            </div>
            <div className="text-center">
              <button onClick={submit} className={styles.opt_button}>
                ログイン
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Otp;
